import React from 'react';

import { useMediaServer } from 'hooks/useMediaServer';
import { replaceByLinkEnv } from 'services/formatter';

type MediaServerProps = {
  path: string;
  children?: ({
    content,
    render,
  }: {
    content?: string;
    render: () => JSX.Element;
  }) => JSX.Element;
};

function MediaServer({ path, children }: MediaServerProps): JSX.Element {
  const { content } = useMediaServer(path);

  if (!content) {
    return <></>;
  }

  function render(content: string) {
    return (
      <div
        className="widget block block-static-block"
        dangerouslySetInnerHTML={{ __html: replaceByLinkEnv(content) }}
      />
    );
  }

  if (!children) {
    return <>{render(content)}</>;
  }

  return <>{children({ content: content, render: () => render(content) })}</>;
}

export default MediaServer;
